import { useQuery } from "@tanstack/react-query";

import { getListing } from "../services/listing";

export const useListing = (listingId) => {
  const query = useQuery({
    queryKey: ["listing", listingId],
    queryFn: () => getListing(listingId, { mark_reviewed: 1 }),
    enabled: !!listingId,
  });

  return {
    listing: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
};
